import React from 'react'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import { sanitizeRegex } from 'utils/text'

interface SubjectItemProps extends React.HTMLProps<HTMLDivElement> {
  subject: string
  selectedSubject: string
  keyword: string
}

const SubjectItem = ({
  subject,
  keyword,
  selectedSubject,
  ...props
}: SubjectItemProps) => {
  const isSelected = subject === selectedSubject
  const regExp = new RegExp(`(${sanitizeRegex(keyword)})`, 'gi')
  const splitSubjectByFoundKeyword = subject
    ?.split(regExp)
    .filter((str) => str !== '')

  return (
    <div
      className="flex cursor-pointer flex-row border-b border-disabled py-3"
      {...props}
    >
      <Text className="flex-1">
        {splitSubjectByFoundKeyword?.map((str, index) => (
          <span
            key={index}
            className={
              str.toLowerCase() === keyword.toLowerCase() || isSelected
                ? 'font-semibold text-[#0b5ae2]'
                : ''
            }
          >
            {str}
          </span>
        ))}
      </Text>

      {isSelected && <Icon className="!text-[#0b5ae2]">done</Icon>}
    </div>
  )
}

export default SubjectItem
